import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greenMui, redMui, rydeColors } from "@ryde/theme";

export const PreviewDrawerLineStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "preview-drawer-line",
})<{ $numberColor?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  width: 100%;

  .saved-rides__label {
    color: ${greenMui._800};
    font-weight: 600;
  }
  .not-saved-rides__label {
    color: ${redMui._700};
    font-weight: 600;
  }

  .ride-too-short__label {
    color: ${redMui._800};
    font-weight: 600;
  }

  span:nth-child(2) {
    font-weight: 700;
    color: ${props => props.$numberColor || rydeColors.black};
  }

  .preview-drawer-line__value--clickable {
    cursor: pointer;
    text-decoration: underline;
  }
`;
